// full updated code (starts here)
import React, { useState, useEffect } from "react";
import Select from "react-select";
import classes from './MakeSale.module.css';
import HeaderNav from '../../Components/Dahboard Header/HeaderNav/HeaderNav';
import Footer from "../../Components/Footer/Footer";
import { Trash2 } from "lucide-react";
import axios from "axios";
import api, { withCompanyId } from "../../Components/API/Api";
import { Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";
import crop from "../../Assets/repoort.png";
import verified from "../../Assets/verified.svg";



const MakeSale = () => {
  const token = localStorage.getItem("authToken");
  const userRole = localStorage.getItem("userType");
  const [productLoading, setProductLoading] = useState(false);
  const location = useLocation();
  // const [invoiceItems, setInvoiceItems] = useState([]);
  const [stores, setStores] = useState([]);
  const [selectedStore, setSelectedStore] = useState("");
  const [storeLoading, setStoreLoading] = useState(false);
  const [currency, setCurrency] = useState("");
  const [showPrint, setShowPrint] = useState(false);
  const [reference, setReference] = useState("");
  const [description, setDescription] = useState("");
  const [amount, setAmount] = useState("");
  const [itemId, setItemId] = useState("");
  const [quantity, setQuantity] = useState("");

  const [currencies, setCurrencies] = useState([]);
  const [responseData, setResponseData] = useState(null);
  // const [services, setServices] = useState([]);
  const navigate = useNavigate();
  const [vatRates, setVatRates] = useState([]);
  const [stocks, setStocks] = useState([]);
  const [products, setProducts] = useState([]);
  const [currencySearch, setCurrencySearch] = useState("");
  const [showCurrency, setShowCurrency] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [customer, setCustomer] = useState('');
  const [selectedCustomerId, setSelectedCustomerId] = useState("");
  const [type, setType] = useState("products");
  const [transactionDate, setTransactionDate] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [selectedCustomerName, setSelectedCustomerName] = useState("");
  const [selectedCurrencyText, setSelectedCurrencyText] = useState("");
  const [apiOptions, setApiOptions] = useState([]);
  const [selectedApiOption, setSelectedApiOption] = useState("");
  const [productss, setProductss] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [loading, setLoading] = useState(false);
  const formatNumberInput = (value) => {
    const raw = value.replace(/,/g, ''); // remove commas
    if (!raw) return '';
    const number = parseFloat(raw);
    if (isNaN(number)) return '';
    return number.toLocaleString();
  };
  const cleanNumber = (value) => {
    const num = parseFloat(String(value).replace(/,/g, ''));
    return isNaN(num) ? "0.00" : num.toFixed(2); // string output
  };

  const [bearer, setBearer] = useState('');


  const readData = async () => {
    try {
      const value = localStorage.getItem('authToken');


      if (value !== null) {
        setBearer(value);
        console.log(value);
      }

    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  // useEffect(() => {
  //   const fetchItems = async () => {
  //     const token = localStorage.getItem("authToken");

  //     try {
  //       const [servicesRes, stocksRes] = await Promise.all([
  //         axios.get(`${BASE_URL}/v1/items/fetch-services`, {
  //           headers: { Authorization: `Bearer ${token}`, Accept: "application/json" }
  //         }),
  //         axios.get(`${BASE_URL}/v1/fetch_stocks`, {
  //           headers: { Authorization: `Bearer ${token}`, Accept: "application/json" }
  //         })
  //       ]);

  //       if (servicesRes?.data?.status) setServices(servicesRes.data.data);
  //       if (stocksRes?.data?.status) setStocks(stocksRes.data.data || []);

  //     } catch (error) {
  //       console.error("Error fetching services/stocks:", error);
  //     }
  //   };

  //   fetchItems();
  // }, []);


  const [items, setItems] = useState([
    { ledger: "", qty: 1, price: 0, discount: 0, discountRate: 0, vat: 0, description: "", total: 0 }
  ]);

  const [invoiceItems, setInvoiceItems] = useState([
    {
      type: "product",
      product_id: "",      // ✅ add this
      product_name: "",
      ledger: "",
      description: "",
      qty: 1,
      price: 0,
      discountRate: "",
      discountAmount: "",
      discount: 0,
      vatRate: "Premium",
      vat: 0,
      wht: 0,
      total: 0
    }
  ]);


  const pageMap = {
    '/dashboard': 'Dashboard',
    '/transactions': 'Transactions',
    '/accounts': 'Accounting',
    '/reports': 'Reports',
    '/banking': 'Banking',
    '/settings': 'Settings',
  };

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const res = await api.get(`/v1/customer`);
        const customerData = res.data?.data?.data || res.data?.data || [];
        setCustomers(customerData);
      } catch (err) {
        console.error("Error fetching customers:", err);
      }
    };
    fetchCustomers();
  }, []);

  // useEffect(() => {
  //   const fetchItems = async () => {
  //     const token = localStorage.getItem("authToken");
  //     try {
  //       const [servicesRes, productsRes] = await Promise.all([
  //         axios.get(`${BASE_URL}/v1/items/fetch-products`, {
  //           headers: {
  //             Authorization: `Bearer ${token}`,
  //             Accept: "application/json"
  //           }
  //         })
  //       ]);
  //       if (productsRes?.data?.status) setProducts(productsRes.data.data);
  //     } catch (error) {
  //       console.error("Error fetching products:", error);
  //     }
  //   };
  //   fetchItems();
  // }, []);


  const fetchInitialData = async () => {
    try {
      const [refRes, currencyRes] = await Promise.all([
        api.get(`/v1/generate-sales-invoice-code`),
        api.get(`/v1/fetch-all-currencies`),
      ]);
      if (refRes?.data?.data) setReference(refRes.data.data.toString());
      if (currencyRes?.data?.data) setCurrencies(currencyRes.data.data);
    } catch (error) {
      console.error("Error fetching initial data:", error);
    }
  };

  useEffect(() => {
    if (bearer)
      fetchInitialData();
  }, [bearer]);

  // Set NGN as default currency once currencies are loaded (if none selected yet)
  useEffect(() => {
    if (!currency && Array.isArray(currencies) && currencies.length > 0) {
      const ngn = currencies.find(cur =>
        (cur.code && String(cur.code).toUpperCase() === 'NGN') ||
        (cur.symbol && (String(cur.symbol).includes('₦') || String(cur.symbol).toUpperCase() === 'NGN')) ||
        (cur.country && String(cur.country).toLowerCase().includes('nigeria'))
      );
      if (ngn) {
        setCurrency(ngn.id);
        setSelectedCurrencyText(`${ngn.symbol} ${ngn.code} - ${ngn.country}`);
      }
    }
  }, [currencies, currency]);

  const handleProductSelect = (rowIndex, productName) => {
    setItems(prevItems => {
      const updatedItems = [...prevItems];
      // const selectedProduct = stocks.find(p => p.name === productName);
      const selectedProduct = Array.isArray(stocks)
        ? stocks.find(p => p.name === productName)
        : undefined;


      updatedItems[rowIndex].ledger = productName;
      if (selectedProduct) {
        updatedItems[rowIndex].price = selectedProduct.price; // auto-fill price
      }
      return updatedItems;
    });
  };

  // 🔹 Fetch Stores (using your customerData guide)
  const fetchStores = async () => {
    setStoreLoading(true);
    try {
      const response = await api.get(`/v1/store`);
      const results = response.data?.data;
      console.log(results)
      setStores(results || []);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate("/login");
      } else {
        const errorStatus = error.response?.data?.message;
        console.error("Store fetch error:", errorStatus);
        setStores([]);
      }
    } finally {
      setStoreLoading(false);
    }
  };

  useEffect(() => {
    if (token) {
      fetchStores();
    }
  }, [token]);

  const fetchProducts = async (id) => {
    setProductLoading(true);
    try {
      const response = await api.get(`/v1/get_store_products`, { params: { store_id: id } });
      const results = response.data?.data || [];
      setProductss(results);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate("/login");
      } else {
        console.error(
          "Error fetching products:",
          error.response?.data?.message
        );
        setProductss([]);
      }
    } finally {
      setProductLoading(false);
    }
  };

  useEffect(() => {
    if (selectedStore?.id) {
      fetchProducts(selectedStore.id);
    } else {
      setProductss([]);   // ✅ fix: clear the right state
      setSelectedProduct(null);
    }
  }, [selectedStore]);




  const handleAddRow = () => {
    setInvoiceItems(prev => [
      ...prev,
      {
        type: "product",
        ledger: "",
        description: "",
        qty: 1,
        price: 0,
        discountRate: "",
        discountAmount: "",
        discount: 0,
        vatRate: "Premium",
        vat: 0,
        wht: 0,
        total: 0
      }
    ]);
  };



  useEffect(() => {
    const fetchVatRates = async () => {
      const token = localStorage.getItem("authToken");
      try {
        const res = await axios.get(`https://api-sme.promixaccounting.com/api/v1/taxes/company-tax`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });

        if (res?.data?.status && Array.isArray(res.data.data)) {
          setVatRates(res.data.data);
        }
      } catch (error) {
        console.error("Failed to fetch VAT rates:", error);
      }
    };

    fetchVatRates();
  }, []);

  const handleDeleteRow = (index) => {
    const updated = [...invoiceItems];
    updated.splice(index, 1);
    setInvoiceItems(updated);
  };
  const clampPct = (v) => {
    const n = parseFloat(v);
    if (isNaN(n)) return 0;
    return Math.max(0, Math.min(100, n));
  };

  const toNumber = (v) => {
    const n = parseFloat(v);
    return isNaN(n) ? 0 : n;
  };

  const recomputeRow = (row, changedField) => {
    const qty = toNumber(row.qty);
    const price = toNumber(row.price);
    const lineAmount = qty * price;

    // Start with raw inputs
    let pct = row.discountRate;
    let amt = row.discountAmount;

    if (changedField === "discountRate") {
      // user edited percent → compute amount
      const p = clampPct(pct);
      amt = lineAmount ? ((p / 100) * lineAmount) : 0;
      row.discountRate = pct === "" ? "" : p; // keep empty if user cleared
      row.discountAmount = pct === "" ? "" : +amt.toFixed(2);
    } else if (changedField === "discountAmount") {
      // user edited amount → compute percent
      const a = Math.max(0, Math.min(lineAmount, toNumber(amt)));
      pct = lineAmount ? (a / lineAmount) * 100 : 0;
      row.discountAmount = amt === "" ? "" : +a.toFixed(2);
      row.discountRate = amt === "" ? "" : +pct.toFixed(2);
    } else {
      // qty/price/other changed → keep them consistent
      if (row.discountRate !== "" && lineAmount) {
        const p = clampPct(row.discountRate);
        row.discountAmount = +((p / 100) * lineAmount).toFixed(2);
        row.discountRate = p;
      } else if (row.discountAmount !== "" && lineAmount) {
        const a = Math.max(0, Math.min(lineAmount, toNumber(row.discountAmount)));
        row.discountRate = +((a / lineAmount) * 100).toFixed(2);
        row.discountAmount = +a.toFixed(2);
      } else {
        row.discountRate = row.discountRate === "" ? "" : 0;
        row.discountAmount = row.discountAmount === "" ? "" : 0;
      }
    }

    // Effective discount is amount
    const discount = toNumber(row.discountAmount);
    const taxable = Math.max(0, lineAmount - discount);

    row.discount = discount;
    row.vat = row.tax_id === 1 ? (taxable * 7.5) / 100 : 0;
    row.wht = row.wht_id === 2 ? 0.02 * taxable : 0;
    row.total = taxable + row.vat + row.wht;

    return row;
  };


  const handleChange = (index, field, value) => {
    setInvoiceItems(prev => {
      const updated = [...prev];
      const row = { ...updated[index], [field]: value };

      // 🔹 Normal User flow (ledger/stocks)
      if (field === "ledger") {
        const selectedItem = Array.isArray(stocks)
          ? stocks.find(item => item.name === value)
          : undefined;
        row.price = selectedItem ? parseFloat(selectedItem.price || selectedItem.cost_price || 0) : 0;
        row.item_id = selectedItem ? selectedItem.id : undefined;
        row.ledger = selectedItem ? selectedItem.name : value;
      }

      // 🔹 Super Admin flow (products)
      if (field === "product_id") {
        const selectedProduct = Array.isArray(productss)
          ? productss.find(p => p.id === value)
          : undefined;
        if (selectedProduct) {
          row.product_id = selectedProduct.id;
          row.product_name = selectedProduct.name;
          row.price = parseFloat(selectedProduct.price || 0);
        } else {
          row.product_id = "";
          row.product_name = "";
          row.price = 0;
        }
      }

      // 🔹 Taxes
      if (field === "vatChecked") row.tax_id = value ? 1 : null;
      if (field === "wthChecked") row.wht_id = value ? 2 : null;

      // 🔹 Recalculate row
      updated[index] = recomputeRow(row, field);
      return updated;
    });
  };




  const subtotal = invoiceItems.reduce((acc, it) => acc + (it.qty * it.price - it.discount), 0);
  const totalVAT = invoiceItems.reduce((acc, it) => acc + it.vat, 0);
  const totalWHT = invoiceItems.reduce((acc, it) => acc + (it.wht || 0), 0);
  const grandTotal = subtotal + totalVAT + totalWHT;


  const handleSaveInvoice = async () => {
    const token = localStorage.getItem("authToken");
    if (
      !reference || !currency ||
      invoiceItems.length === 0 ||
      invoiceItems.some(item => {
        const idCheck = userRole === "Super Admin" ? !item.product_id : !item.item_id;
        return (
          idCheck ||
          item.description === "" ||
          item.qty === "" ||
          item.price === "" ||
          item.total === ""
        );
      })
    ) {
      Swal.fire("Missing Fields", "Please fill all required fields.", "warning");
      return;
    }






    // arrays expected by API
    const item_id = [];
    const quantity = [];
    const item_amount = [];
    const referencePerItem = [];
    const tax_id = [];
    const wht_id = [];
    const discount = [];
    const discount_percentage = [];

    let sub_total = 0;
    let total_discount = 0;
    let total_vat = 0;
    let total_wht = 0;

    invoiceItems.forEach((row) => {
      const qty = Number(row.qty) || 0;
      const price = Number(row.price) || 0;
      const lineAmount = qty * price;
      const discountAmt = Number(row.discount) || 0;       // your recomputeRow sets this
      const taxable = Math.max(0, lineAmount - discountAmt);

      const vat = Number(row.vat) || 0;
      const wht = Number(row.wht) || 0;

      if (userRole === "Super Admin") {
        item_id.push(row.product_id);
      } else {
        item_id.push(row.item_id);
      }
      quantity.push(qty);
      item_amount.push(+lineAmount.toFixed(2));            // send price * qty ONLY
      referencePerItem.push(String(row.description ?? "").trim());

      tax_id.push(row.tax_id ?? null);
      wht_id.push(row.wht_id ?? null);

      // per-line discount amount (null if no discount)
      discount.push(discountAmt > 0 ? +discountAmt.toFixed(2) : null);

      // per-line discount percentage (null if not provided)
      const pct = row.discountRate === "" ? null : Number(row.discountRate);
      discount_percentage.push(pct && pct > 0 ? +pct.toFixed(2) : null);

      // totals
      sub_total += taxable;       // after discount, before tax
      total_discount += discountAmt;
      total_vat += vat;
      total_wht += wht;
    });

    const grand_total = sub_total + total_vat + total_wht;

    const payload = {
      // invoice-level
      invoice_number: reference,
      currency: currency,
      description: "make sales successful",
      sales_type: 'credit',
      customer_id: customer || '',
      // line arrays (aligned)
      item_id,
      quantity,
      item_amount,
      reference: referencePerItem,
      tax_id,
      wht_id,
      discount,
      discount_percentage,

      // totals
      sub_total: +sub_total.toFixed(2),
      total_discount: +total_discount.toFixed(2),
      total_vat: +total_vat.toFixed(2),
      total_wht: +total_wht.toFixed(2),
      amount: +grand_total.toFixed(2),
      total_price: +grand_total.toFixed(2),
    };




    setIsSaving(true);
    try {
      const res = await api.post(`/v1/make_sales`, withCompanyId(payload));
      setResponseData(res?.data?.data);
      Swal.fire({
        imageUrl: verified,
        title: "Success!",
        text: res.data.message || "Invoice saved successfully!",
        confirmButtonText: "Okay",
        imageWidth: 48,
        imageHeight: 48,
        customClass: {
          title: classes.myTitle,
          popup: classes.myText,
          confirmButton: classes.myButton,
        },
        allowOutsideClick: false,
        preConfirm: () => {
          Swal.close();
        },
      });

      setShowPrint(true);
      fetchInitialData();
      setInvoiceItems([]);
    } catch (error) {
      const msg = error?.response?.data?.message || "Network error";

      // ❌ Custom failure alert
      Swal.fire({
        imageUrl: crop,
        imageWidth: 48,
        imageHeight: 48,
        title: "Failed!",
        confirmButtonText: "Okay",
        text: JSON.stringify(msg),
        customClass: {
          title: classes.myTitle,
          popup: classes.myText,
          confirmButton: classes.myDeclineButton,
        },
        allowOutsideClick: false,
        preConfirm: () => {
          Swal.close();
        },
      });
    } finally {
      setIsSaving(false);
    }
  };

  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const currencyOptions = currencies.map(cur => ({
    value: cur.id,
    label: `${cur.symbol} ${cur.code} - ${cur.country}`,
    currency: cur
  }));

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const res = await api.get(`/v1/customer`);
        const customerData = res.data?.data?.data || res.data?.data || [];
        setCustomers(customerData);
      } catch (err) {
        console.error("Error fetching customers:", err);
      }
    };
    fetchCustomers();
  }, []);


  const totalDiscount = invoiceItems.reduce((sum, item) => sum + (item.discount || 0), 0);
  const totalVat = invoiceItems.reduce((sum, item) => sum + (item.vat || 0), 0);
  const totalWht = invoiceItems.reduce((sum, item) => sum + (item.wht || 0), 0);  // ✅ new
  const totalAmount = invoiceItems.reduce((sum, item) => sum + (item.total || 0), 0);

  const handlePrintReceipt = () => {
    navigate("/printreceipts", {
      state: {
        responseData
      },
    });

  }
  const handlePOSReceipt = () => {
    navigate("/pos_receipt", {
      state: {
        result: responseData,
        mode: "pos",
      },
    });

  };
  console.log(responseData);

  return (
    <div>
      <HeaderNav activePage={pageMap[location.pathname]} />
      <div className={classes.Container}>
        <header className={classes.Header}>
          <h2 className={classes.Title}>Make Sales </h2>
        </header>
        <form className={classes.form}>
          <div className={classes.group1}>
            <label>Customer Name</label>
            <input
              type="text"
              placeholder="Enter Customer Name"
              value={customer}
              onChange={(e) => setCustomer(e.target.value)}
              className={classes["select-search"]}
              required
            />
          </div>



          {/* <div className={classes.group1}>
            <label>Invoice Date</label>
            <input type="date" value={transactionDate} onChange={(e) => setTransactionDate(e.target.value)} required />
          </div> */}
          {/* <div className={classes.group1}>
            <label>Due Date</label>
            <input type="date" value={dueDate} onChange={(e) => setDueDate(e.target.value)} required />
          </div> */}
          <div className={classes.group2}>
            <label>Reference</label>
            <input type="text" value={reference} readOnly />
          </div>

          <div className={classes.group1}>
            <label>Currency</label>
            <div
              className={`${classes["select-container"]} ${showCurrency ? classes.active : ""
                }`}
            >
              <input
                type="text"
                placeholder="Search Currency..."
                value={currencySearch !== "" ? currencySearch : selectedCurrencyText}
                onClick={() => {
                  setShowCurrency(true);
                  setCurrencySearch(""); // allow fresh typing
                }}
                onChange={(e) => {
                  setCurrencySearch(e.target.value);
                  setShowCurrency(true);
                }}
                className={classes["select-search"]}
                required
              />
              {showCurrency && (
                <div className={classes["select-dropdown"]}>
                  {currencies
                    .filter((cur) =>
                      currencySearch
                        ? `${cur.symbol} ${cur.code} - ${cur.country}`
                          .toLowerCase()
                          .includes(currencySearch.toLowerCase())
                        : true
                    )
                    .map((cur) => (
                      <div
                        key={cur.id}
                        className={classes["select-option"]}
                        onClick={() => {
                          setCurrency(cur.id); // ✅ store ID for backend
                          setSelectedCurrencyText(
                            `${cur.symbol} ${cur.code} - ${cur.country}`
                          ); // ✅ store label for UI
                          setCurrencySearch(""); // reset search input
                          setShowCurrency(false);
                        }}
                      >
                        {cur.symbol} {cur.code} - {cur.country}
                      </div>
                    ))}
                </div>
              )}
            </div>
          </div>

          {
            userRole === "Super Admin" && (
              <div className={classes.group1}>
                <label className={classes.label}>Select Store</label>
                <Select
                  isLoading={storeLoading}
                  options={stores.map((store) => ({
                    value: store.id,
                    label: store.store_name,
                  }))}
                  value={
                    selectedStore
                      ? { value: selectedStore.id, label: selectedStore.name }
                      : null
                  }
                  onChange={(option) => {
                    if (option) {
                      setSelectedStore({ id: option.value, name: option.label });
                    } else {
                      setSelectedStore(null);
                    }
                  }}
                  placeholder="Select a store..."
                  className={classes.select}
                />
              </div>
            )
          }

        </form>

        <div className={classes.invoicecont}>

          <table className={classes.invoiceTable}>
            <thead>
              <tr>
                <th>Product</th>
                <th>Description</th>
                <th>Qty/Hrs*</th>
                <th>Price/Rate*</th>
                <th>Discount(%)</th>
                <th>Discount Amount</th>
                <th>VAT</th>
                <th>WHT</th>
                <th>Total</th>
                <th><button type="button" className={classes.addRowBtn} onClick={handleAddRow}>+</button></th>
              </tr>
            </thead>
            <tbody>
              {invoiceItems.map((item, idx) => (
                <tr key={idx}>

                  {
                    userRole === "Super Admin" ? (
                      <td className={classes.productCell}>
                        <Select
                          isLoading={productLoading}
                          options={productss.map((p) => ({
                            value: p.id,
                            label: p.name,
                            price: p.price,
                          }))}
                          value={
                            productss
                              .map((p) => ({ value: p.id, label: p.name, price: p.price }))
                              .find((opt) => opt.value === item.product_id) || null
                          }
                          onChange={(option) => {
                            if (option) {
                              handleChange(idx, "product_id", option.value);
                              handleChange(idx, "product_name", option.label);
                              handleChange(idx, "price", option.price);  // ✅ fills price
                            } else {
                              handleChange(idx, "product_id", "");
                              handleChange(idx, "product_name", "");
                              handleChange(idx, "price", "");
                            }
                          }}
                          placeholder="Select a product..."
                          isDisabled={!selectedStore}
                        />
                      </td>



                    ) : (
                      <td className={classes.productCell}>
                        <input
                          list={`stockList-${idx}`}
                          value={item.ledger}
                          onChange={(e) => {
                            const selectedName = e.target.value;
                            const selectedStock = Array.isArray(stocks)
                              ? stocks.find(stock => stock.name === selectedName)
                              : undefined;

                            handleChange(idx, 'ledger', selectedName);
                            if (selectedStock) {
                              handleChange(idx, 'price', selectedStock.price);
                              handleChange(idx, 'item_id', selectedStock.id);
                            }
                          }}
                          placeholder="Search or type stock item"
                        />
                        <datalist id={`stockList-${idx}`}>
                          {Array.isArray(stocks) && stocks.map(stock => (
                            <option key={stock.id} value={stock.name}>
                              {stock.name}
                            </option>
                          ))}
                        </datalist>
                      </td>
                    )

                  }

                  <td className={classes.descriptionCell}>
                    <input
                      type="text"
                      value={item.description}
                      onChange={(e) => handleChange(idx, 'description', e.target.value)}
                    />
                  </td>

                  <td>
                    <input
                      type="number"
                      value={item.qty}
                      onChange={(e) => handleChange(idx, "qty", e.target.value)}
                      placeholder="Qty/Hrs*"
                      required
                    />
                  </td>


                  <td>
                    <input
                      type="number"
                      value={item.price}
                      onChange={(e) => handleChange(idx, "price", e.target.value)}
                      placeholder="Price/Rate*"
                      required
                      className={classes.totalInput}
                    />
                  </td>

                  <td>
                    <input
                      type="number"
                      min={0}
                      max={100}
                      step="0.01"
                      value={item.discountRate === "" ? "" : item.discountRate}
                      onChange={(e) => handleChange(idx, "discountRate", e.target.value)}
                      placeholder="%"                // no default 0
                      className={classes.discountInput}
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      min={0}
                      step="0.01"
                      value={item.discountAmount === "" ? "" : item.discountAmount}
                      onChange={(e) => handleChange(idx, "discountAmount", e.target.value)}
                      placeholder="0.00"             // no default value; hint only
                      className={classes.totalInput}
                    />
                  </td>
                  <td>
                    <input
                      type="checkbox"
                      checked={item.vatChecked || false}
                      onChange={(e) => handleChange(idx, 'vatChecked', e.target.checked)}
                    />
                  </td>
                  {/* <td>
                    <select value={item.vatRate} onChange={(e) => handleChange(idx, 'vatRate', e.target.value)}>
                      <option value="">Select VAT</option>
                      {vatRates.map((rate) => (
                        <option key={rate.id} value={rate.rate}>
                          {rate.description} - {rate.rate}%
                        </option>
                      ))}
                    </select>

                  </td> */}
                  {/* <td><input type="number" value={item.vat.toFixed(2)} readOnly className={classes.vatInput} /></td> */}
                  <td>
                    <input
                      type="checkbox"
                      checked={item.wthChecked || false}
                      onChange={(e) => handleChange(idx, 'wthChecked', e.target.checked)}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      value={Number(item.total).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                      readOnly
                      className={classes.totalInput}
                    />
                  </td>



                  <td><Trash2 size={16} onClick={() => handleDeleteRow(idx)} className={classes.deleteIcon} /></td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className={classes.paginationContainer}>
            <div className={classes.paginationControls}>
              <button>First</button>
              <button className={classes.active}>1</button>
              <button>2</button>
              <button>Last</button>
              <span className={classes.pageText}>Displaying 1 - {invoiceItems.length} of {invoiceItems.length}</span>
            </div>
          </div>

          <div className={classes.foot}>
            <div className={classes.Footer}>
              <div className={`${classes.footerSection} ${classes.comments}`}>
                <label>Message</label>
                <textarea className={classes.commentsBox}></textarea>
              </div>

              <div className={`${classes.footerSection} ${classes.summary}`}>
                <div className={classes.grouppp}>
                  <label>Total V.A.T:</label>
                  <input
                    type="text"
                    value={totalVat.toFixed(2)}   // ✅ always 2 decimals
                    readOnly
                    className={classes.summaryInput}
                  />
                </div>

                <div className={classes.grouppp}>
                  <label>Total W.H.T:</label>
                  <input
                    type="text"
                    value={totalWht.toFixed(2)}   // ✅
                    readOnly
                    className={classes.summaryInput}
                  />
                </div>

                <div className={classes.grouppp}>
                  <label>Total Discount:</label>
                  <input
                    type="text"
                    value={totalDiscount.toFixed(2)}   // ✅
                    readOnly
                    className={classes.summaryInput}
                  />
                </div>

                <div className={classes.grouppp}>
                  <label>Total Amount:</label>
                  <input
                    type="text"
                    value={totalAmount.toFixed(2)}   // ✅
                    readOnly
                    className={classes.summaryInput}
                  />
                </div>

                <div className={classes.actionButtons}>
                  <button className={classes.cancelButton}>Cancel</button>
                  <button
                    className={classes.saveButton}
                    type="button"
                    onClick={handleSaveInvoice}
                    disabled={isSaving}
                  >
                    {isSaving ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          className="me-2"
                        />
                        Saving...
                      </>
                    ) : (
                      "Save"
                    )}
                  </button>
                </div>

                {showPrint && (
                  <div className={classes.actionButtonss}>
                    <button className={classes.cancelButton} onClick={handlePOSReceipt}>
                      Print POS Receipt
                    </button>
                    <button
                      className={classes.saveButton}
                      type="button"
                      onClick={handlePrintReceipt}
                    >
                      Print Receipt
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>

        </div>

        <Footer />
      </div>
    </div>
  );
};

export default MakeSale;
